import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";

/**
 * Installs the specified GSAP plugins, provided they have been loaded already.
 * Implicitly registers useGSAP plugin.
 *
 * @source https://gsap.com/docs/v3/GSAP/gsap.registerPlugin()/
 * @important All plugins, including useGSAP, must be imported before calling this function.
 */
export function registerGsapPlugins(...plugins: gsap.RegisterablePlugins[]) {
  if (typeof window !== "undefined") {
    gsap.registerPlugin(useGSAP, ...plugins);
  }
}
